import React from 'react';
import { useLocation } from 'react-router-dom';
import { WhatsAppMenu } from './WhatsAppMenu';

export const WhatsAppFloat: React.FC = () => {
  const location = useLocation();

  // 不在後台顯示浮動按鈕
  if (location.pathname.startsWith('/admin')) return null;

  return <WhatsAppMenu variant="float" />;
};

export default WhatsAppFloat;
